import React from "react";
import "./Digitalmarketing.css";

function Digitalmarketing(){

    return(
        <div className="contents">
  <div className="container">
  {/* <!-- Row 1: Three Cards --> */}
  <div className="row justify-content-center g-4">
    <div className="col-md-4">
      <div className="cardid card border border-dark">

                      <div className="corner-circle"></div>

        <div className="card-body">
          <h5 className="card-title">
              <img src="socialmedia.png" alt="Logo"/>
           Social Media Marketing (SMM)</h5>
          <p className="card-text">We create engaging and creative content for platforms like Facebook, Instagram, and YouTube to increase your brand visibility and customer interaction. Our targeted ad campaigns and consistent posting help you connect with the right audience and grow your followers organically.</p>
        </div>
      </div>
    </div>
    <div className="col-md-4">
      <div className=" cardid card  border border-dark">

                      <div className="corner-circle "></div>

        <div className="card-body">
         <h5 className="card-title">
        <img src="searchengine.png" alt="Logo"/>
            Search Engine Optimization (SEO)</h5>
          <p className="card-text">We improve your website’s ranking on search engines like Google through proven SEO strategies. From keyword optimization to backlink building and technical improvements, <br/>
          we help your website appear on top for relevant searches and attract quality traffic.</p>
        </div>
      </div>
    </div>
    <div className="col-md-4">
      <div className="cardid card  border border-dark">

                              <div className="corner-circle "></div>

        <div className="card-body">
          <h5 className="card-title">
          <img src="Google.png" alt="Logo"/>
            Google Ads (PPC Advertising)</h5>
          <p className="card-text">We run targeted Google Ads campaigns that bring immediate traffic and leads to your business. Whether it's search ads, display banners,<br/>
           or YouTube ads, we optimize<br/>
            every rupee spent<br/>
           to give you the best ROI with measurable results.</p>
        </div>
      </div>
    </div>
  </div>

  <div className="row justify-content-center g-4 mt-3">
    <div className="col-md-4">
      <div className="cardid card  border border-dark">

                              <div className="corner-circle "></div>

        <div className="card-body">
          <h5 className="card-title">
          <img src="content.png" alt="Logo"/>
            Content Marketing</h5>
          <p className="card-text">We create valuable and SEO-optimized content such as blogs, articles, landing pages, and social media captions that educate, inform, and convert. Our content marketing builds trust and positions your brand as a leader in your niche.</p>
        </div>
      </div>
    </div>
    <div className="col-md-4">
      <div className="cardid card  border border-dark">

                              <div className="corner-circle "></div>

        <div className="card-body">
          <h5 className="card-title">
          <img src="email.png" alt="Logo"/>
           Email & WhatsApp Marketing</h5>
          <p className="card-text">We help you stay connected with your customers through professional email campaigns and WhatsApp messages. From promotions to follow-ups, we craft personalized communication that increases retention and encourages repeat business.</p>
        </div>
      </div>
    </div>
  </div>
</div>


<button type="button" className="exitbutton btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
  Move to Previous
</button>


<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Exit page</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
      Are You Really want to Exit this page..
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">No</button>
        <button type="button" class="btn btn-primary">Yes</button>
      </div>
    </div>
  </div>
</div>


        </div>
    )

}
export default Digitalmarketing;